import { ThunkAction } from 'redux-thunk';
import { AxiosResponse } from 'axios';
import store from 'store';
import ApiClient, { createTokenConfig, isCancelled } from 'api/ApiClient';
import { NotificationsAction, showError } from '@spike/notifications-action';
import {
    WEEKLY_BREAKDOWN_REPORT_GET_START,
    WEEKLY_BREAKDOWN_REPORT_GET_SUCCESS,
    WEEKLY_BREAKDOWN_REPORT_GET_ERROR,
    WeeklyBreakdownReportAction
} from './WeeklyBreakdownReportActionsTypes';
import { WeeklyBreakdownReportDto } from './WeeklyBreakdownReportDto';
import { convertToWeeklyBreakdownReport } from './weeklyBreakdownConverter';
import { WeeklyBreakdownReport } from 'model/BookingsWeeklyBreakdownReport';

export const getWeeklyBreakdownReport = (
    start?: string,
    end?: string
): ThunkAction<void, null, null, WeeklyBreakdownReportAction | NotificationsAction> => {
    return async dispatch => {
        dispatch(getStart());

        const { marketplaceId } = store.getState().login.auth;
        const timeZone = store.getState().login.auth.timeZone;

        let url = `/weekly_breakdown_report?marketplace_id=${marketplaceId}`;
        if (start) url += `&start=${start}`;
        if (end) url += `&end=${end}`;

        try {
            const response: AxiosResponse<WeeklyBreakdownReportDto> = await ApiClient.get(
                url,
                createTokenConfig(store.getState().login.auth.token!)
            );

            dispatch(getSuccess(convertToWeeklyBreakdownReport(response.data, timeZone!)));
        } catch (apiError) {
            if (!isCancelled(apiError)) {
                dispatch(getError());
                dispatch(showError('Too many records to display. Please try a shorter date range.'));
            }
        }
    };
};

const getStart = (): WeeklyBreakdownReportAction => ({
    type: WEEKLY_BREAKDOWN_REPORT_GET_START
});

const getSuccess = (report: WeeklyBreakdownReport): WeeklyBreakdownReportAction => ({
    type: WEEKLY_BREAKDOWN_REPORT_GET_SUCCESS,
    payload: { report }
});

const getError = (): WeeklyBreakdownReportAction => ({
    type: WEEKLY_BREAKDOWN_REPORT_GET_ERROR
});
